<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M18.5 24.15L23.2 19.45L18.4 14.65L16 17.1L15.2 16.3L17.65 13.9L12.8 9.05L8.1 13.75L18.5 24.15ZM34.2 39.85L38.9 35.15L34.05 30.3L31.65 32.75L30.85 31.95L33.25 29.55L28.55 24.8L23.85 29.5L34.2 39.85ZM14.05 39.4H8.6V33.95L17.7 24.85L6.6 13.75L12.75 7.55L23.95 18.7L33.7 8.95C33.8333 8.81667 33.9667 8.725 34.1 8.675C34.2333 8.625 34.3833 8.6 34.55 8.6C34.6833 8.6 34.8167 8.625 34.95 8.675C35.0833 8.725 35.2167 8.81667 35.35 8.95L39.05 12.8C39.1833 12.9333 39.2667 13.0667 39.3 13.2C39.3333 13.3333 39.35 13.4667 39.35 13.6C39.35 13.7667 39.3333 13.9083 39.3 14.025C39.2667 14.1417 39.1833 14.2667 39.05 14.4L29.4 24.05L40.45 35.2L34.3 41.4L23.15 30.3L14.05 39.4ZM9.7 38.3H13.55L33.25 18.6L29.4 14.75L9.7 34.45V38.3Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>